module.exports = __webpack_public_path__ + "static/media/code.c7dc30cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/logos/code.png
// module id = 361
// module chunks = 0